/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Target_LanguagesInputs */

const en_target_languages = /** @type {(inputs: Target_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Target Languages`)
};

const fr_target_languages = /** @type {(inputs: Target_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langues cibles`)
};

const de_target_languages = /** @type {(inputs: Target_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zielsprachen`)
};

const it_target_languages = /** @type {(inputs: Target_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lingue di destinazione`)
};

const ru_target_languages = /** @type {(inputs: Target_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Целевые языки`)
};

const es_target_languages = /** @type {(inputs: Target_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idiomas de destino`)
};

const zh_cn2_target_languages = /** @type {(inputs: Target_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目标语言`)
};

const ja_target_languages = /** @type {(inputs: Target_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`対象言語`)
};

const hi_target_languages = /** @type {(inputs: Target_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लक्ष्य भाषाएँ`)
};

const pt_pt2_target_languages = /** @type {(inputs: Target_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Línguas-alvo`)
};

/**
* | output |
* | --- |
* | "Target Languages" |
*
* @param {Target_LanguagesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const target_languages = /** @type {((inputs?: Target_LanguagesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Target_LanguagesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_target_languages(inputs)
	if (locale === "de") return de_target_languages(inputs)
	if (locale === "it") return it_target_languages(inputs)
	if (locale === "ru") return ru_target_languages(inputs)
	if (locale === "es") return es_target_languages(inputs)
	if (locale === "zh-CN") return zh_cn2_target_languages(inputs)
	if (locale === "ja") return ja_target_languages(inputs)
	if (locale === "hi") return hi_target_languages(inputs)
	if (locale === "pt-PT") return pt_pt2_target_languages(inputs)
	return en_target_languages(inputs)
});